import React, { FC, memo } from 'react';
import { IImageButtonProps, ImageButton } from '@components/ImageButton/ImageButton';
import { MyAccountSidebar } from '@components/MyAccountSidebar';
import routes from 'src/constants/routes';
import { useUserDuck } from '@hooks/useUserDuck';
import { useFeatureSwitch } from '@hooks/useFeatureSwitch';

export const MyAccountHomeController: FC = memo(() => {
    const { isMyAccountOrdersDisabled, isDealerLayerEnabled } = useFeatureSwitch();

    const {
        summary: { totalOrders, totalSaves },
    } = useUserDuck();

    const myOrderDescEc41 = isDealerLayerEnabled && totalOrders.total === 0;
    const mySavesProps: IImageButtonProps = {
        title: 'myaccount.nav.mySaves',
        description: 'myaccount.mySaves.desc',
        counter: totalSaves.total,
        imgUrl: totalSaves.img,
        href: routes.MY_SAVES,
        alt: Boolean(totalSaves.total)
            ? `${totalSaves.grBodyStyle.description} ${totalSaves.nameplate.description}`
            : '',
    };
    const myOrdersProps: IImageButtonProps = {
        title: 'myaccount.nav.myOrders',
        description: myOrderDescEc41 ? 'myaccount.myOrders.desc.empty' : 'myaccount.myOrders.desc',
        counter: totalOrders.total,
        imgUrl: totalOrders.img,
        href: routes.MY_ORDERS,
        usePxNotification: true,
        alt: Boolean(totalOrders.total)
            ? `${totalOrders.grBodyStyle?.description} ${totalOrders.nameplate?.description}`
            : '',
    };

    return (
        <div className="my-account-controller">
            <div className="my-account-home">
                <div className={`imgbtn ${totalSaves.total > 0 ? 'active' : 'inactive'}`}>
                    <ImageButton {...mySavesProps} />
                </div>

                {!isMyAccountOrdersDisabled ? (
                    <div className={`imgbtn ${totalOrders.total > 0 ? 'active' : 'inactive'}`}>
                        <ImageButton {...myOrdersProps} />
                    </div>
                ) : (
                    <div className="sectionPlaceholder" />
                )}
            </div>
            <div className="my-account-menu">
                <MyAccountSidebar />
            </div>
        </div>
    );
});
MyAccountHomeController.displayName = 'MyAccountHomeController';
